import { render, staticRenderFns } from "./CreateSmallInstitution.vue?vue&type=template&id=54f609ee&scoped=true&"
import script from "./CreateSmallInstitution.vue?vue&type=script&lang=js&"
export * from "./CreateSmallInstitution.vue?vue&type=script&lang=js&"
import style0 from "./CreateSmallInstitution.vue?vue&type=style&index=0&id=54f609ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f609ee",
  null
  
)

export default component.exports